import { apiClientV2 } from "./configs/axiosConfig";

export interface NotificationData {
  id_notify: string;
  id_user: string;
  send_date: string | null;
  read_date: string | null;
  notification_type: string | null;
  title: string;
  body: string | null;
  state: string | null;
  cta_label: string | null;
  cta_name: string | null;
  cta_info: string | null;
}

interface NotificationAPIResponse {
  status: number;
  message: string;
  data: NotificationData[];
}

export class NotificationAPI {
  static async getNotifications(): Promise<NotificationAPIResponse> {
    const response = await apiClientV2.request({
      url: `social_hub/notifications`,
      method: "POST",
      data: {
        query_parameters: {
          fields: "*"
        },
        extra: {
          get_extra_fields: true,
          get_imgs: true
        }
      },
    });
    return response.data;
  }

  static async readNotification(
    notification_id: string
  ): Promise<{ status: number; message: string; data: boolean }> {
    const response = await apiClientV2.request({
      url: `social_hub/read_notifications`,
      method: "POST",
      data: {
        id_notification: parseInt(notification_id)
      },
    });
    return response.data;
  }
}
